var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx } from 'clsx';
import RadioCheckboxCard from '../RadioCheckboxCard';
var ExpandableRadioCard = function (_a) {
    var className = _a.className, checked = _a.checked, _b = _a.isValid, isValid = _b === void 0 ? true : _b, expandedComponent = _a.expandedComponent, radioChildren = _a.radioChildren, radioClassName = _a.radioClassName, radioOnInputChange = _a.radioOnInputChange, radioOptionId = _a.radioOptionId, radioValue = _a.radioValue, showExpansion = _a.showExpansion;
    return (_jsxs("div", __assign({ className: clsx('group', className) }, { children: [_jsx(RadioCheckboxCard, __assign({ className: radioClassName, checked: checked, isExpanded: showExpansion, isValid: isValid, name: "body-condition", onInputChange: radioOnInputChange, optionId: radioOptionId, type: "radio", value: radioValue }, { children: radioChildren })), showExpansion && (_jsx("div", __assign({ className: clsx('border-2 rounded-b-[12px] bg-bone -mt-3', checked && !isValid ? 'border-error-red' : 'border-shoe', 'group-has-[input:focus]:ring-2 group-has-[input:focus]:ring-shoe') }, { children: expandedComponent })))] })));
};
export default ExpandableRadioCard;
